import {StepsList} from '../../../../shared/campaign/StepsList';
import {useTranslation} from 'react-i18next';

export default function ArtQueueProgressList({steps = [], title}) {
  const {t} = useTranslation();

  return (
    <StepsList
      steps={steps}
      title={title || t('campaignChat.artProgress.title', 'Gerando artes...')}
    />
  );
}
